import * as React from 'react'
import type { SVGProps } from 'react'

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 126.92 125.26"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M125.42,125.26H55.73c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h68.19v-63.33h-8.55l-16.25,17.09c-.42.44-1.07.59-1.64.36-.57-.23-.94-.78-.94-1.39v-16.06h-8.55l-16.25,17.09c-.42.44-1.07.59-1.64.36-.57-.23-.94-.78-.94-1.39v-16.06h-8.55l-7.34,7.72c-.57.6-1.52.63-2.12.05-.6-.57-.62-1.52-.05-2.12l7.79-8.19c.28-.3.68-.47,1.09-.47h10.7c.83,0,1.5.67,1.5,1.5v13.8l14.1-14.83c.28-.3.68-.47,1.09-.47h10.7c.83,0,1.5.67,1.5,1.5v13.8l14.1-14.83c.28-.3.68-.47,1.09-.47h10.7c.83,0,1.5.67,1.5,1.5v66.33c0,.83-.67,1.5-1.5,1.5Z" />
        <path d="M109.15,95.22h-49.62c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h49.62c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z" />
        <path d="M45.05,125.26H1.5c-.41,0-.81-.17-1.09-.47-.28-.3-.43-.71-.4-1.12L5.76,29.82c.05-.79.7-1.41,1.5-1.41h32.02c.79,0,1.45.62,1.5,1.41l5.76,93.85c.03.41-.12.82-.4,1.12-.28.3-.68.47-1.09.47ZM3.09,122.26h40.36l-5.58-90.85H8.67L3.09,122.26Z" />
        <path d="M73.38,40.13c-6.32,0-12.95-1.62-19.87-4.85-.3-.14-.56-.26-.79-.37-.75-.34-1.09-1.23-.75-1.98.34-.76,1.23-1.09,1.98-.75.24.11.51.24.83.38,20.16,9.43,37.71,4,52.19-16.12C62.39-8.36,37.14,6.75,26.01,18.06c-.58.59-1.53.6-2.12.02-.59-.58-.6-1.53-.02-2.12,11.86-12.05,38.8-28.25,86.02-1.32.36.21.63.56.72.97.09.41.01.84-.23,1.19-10.73,15.54-23.12,23.33-37.01,23.33Z" />
        <path d="M75.92,21.54c-.08,0-.17,0-.25-.02-6.95-1.17-26.17-3.72-31.53-1.52-.77.32-1.64-.05-1.96-.82-.31-.77.05-1.64.82-1.96,7.12-2.92,30.52.9,33.17,1.34.82.14,1.37.91,1.23,1.73-.12.73-.76,1.25-1.48,1.25Z" />
      </g>
    </svg>
  )
}

export default Icon
